import { ActionReducerMap } from '@ngrx/store';
import { IAppState } from './app.state';
import { teamsReducer } from './teams/teams.reducers';
import { usersReducer } from "./users/users.reducers";
import { usersForClientFilterReducer } from './users/users.reducers';
import { companyLogoReducer } from './companyLogo/companyLogo.reducers';
import { taricCodesReducer } from './taricCodes/taricCodes.reducers';
import { clientsReducer } from './clients/clients.reducers';
import { contractsReducer } from './contracts/contracts.reducers';
import { ibanRegionsReducer } from './ibanRegions/ibanRegions.reducers';
import { caensReducer } from './caens/caens.reducers';
import { articlesReducer } from "./articles/articles.reducers";
import { loggedUserPermissionsReducer, permissionsReducer, userPermissionsReducer } from './permissions/permissions.reducers';
import { parnersReducer } from './parners/parners.reducers';
import { appendixesReducer, appendixTypesReducer } from './appendix/appendix.reducers';
import { locationsReducer } from './locations/locations.reducers';
import { unitCodesReducer } from './unitCodes/unitCodes.reducers';
import { groupsArticlesReducer } from './groupsArticles/groupsArticles.reducers';
import { gestiuniReducer } from './gestiuni/gestiuni.reducers';
import { vatsReducer } from './vats/vats.reducers';
import { costCentersReducer } from './costCenters/costCenters.reducers';
import {employeesReducer} from "./employees/employees.reducers";

export const appReducers: ActionReducerMap<IAppState> = {
  teams: teamsReducer,
  users: usersReducer,
  articles: articlesReducer,
  companyLogo: companyLogoReducer,
  taricCodes: taricCodesReducer,
  clients: clientsReducer,
  contracts: contractsReducer,
  caens: caensReducer,
  ibanRegions: ibanRegionsReducer,
  usersForClientFilter: usersForClientFilterReducer,
  permissions: permissionsReducer,
  userPermissions: userPermissionsReducer,
  parners: parnersReducer,
  loggedUserPermissions: loggedUserPermissionsReducer,
  appendixes: appendixesReducer,
  appendixTypes: appendixTypesReducer,
  locations: locationsReducer,
  unitCodes: unitCodesReducer,
  groupsArticles: groupsArticlesReducer,
  gestiuni: gestiuniReducer,
  vats: vatsReducer,
  costCenters: costCentersReducer,
  employees: employeesReducer,
};
